import * as THREE from 'three';
import { ConfiguratorModule } from '../types';

/*
 * Accessories configurator module.
 * Placeholder: a stylised ring with a gem stone.
 */
const accessories: ConfiguratorModule = {
  type: 'accessories',
  label: 'Accessories',
  // modelPath: '/models/accessories.glb',

  buildPlaceholder(): THREE.Object3D {
    const group = new THREE.Group();
    group.name = 'placeholder-accessories';

    // Band
    const bandMat = new THREE.MeshStandardMaterial({
      color: 0xce93d8,
      roughness: 0.1,
      metalness: 0.85,
    });
    const band = new THREE.Mesh(
      new THREE.TorusGeometry(0.7, 0.18, 20, 80),
      bandMat
    );
    band.castShadow = true;
    group.add(band);

    // Setting (bezel around gem)
    const bezelMat = new THREE.MeshStandardMaterial({
      color: 0xd4af37,
      roughness: 0.05,
      metalness: 1.0,
    });
    const bezel = new THREE.Mesh(
      new THREE.CylinderGeometry(0.22, 0.25, 0.12, 24),
      bezelMat
    );
    bezel.position.set(0, 0.7, 0);
    bezel.castShadow = true;
    group.add(bezel);

    // Gem
    const gemMat = new THREE.MeshStandardMaterial({
      color: 0x80deea,
      roughness: 0.0,
      metalness: 0.3,
      emissive: new THREE.Color(0x006064),
      emissiveIntensity: 0.4,
    });
    const gem = new THREE.Mesh(new THREE.OctahedronGeometry(0.2, 0), gemMat);
    gem.position.set(0, 0.82, 0);
    gem.castShadow = true;
    group.add(gem);

    return group;
  },
};

export default accessories;
